import { Locale, OutputChannels } from '../types';

export enum LocaleActions {
  SetLocale = 'LOCALE/SET',
  SetOnlineChannel = 'LOCALE/SET_ONLINE_CHANNEL',
}

export interface LocaleStore {
  locale: Locale;
  onlineChannel: OutputChannels;
}
